/* eslint-disable @typescript-eslint/naming-convention */
import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const text_default_color = "#465869";
const text_second_color = "#308CDB";
const background_second_color = "rgba(48, 140, 219, 0.1)";

const styles = makeStyles<Theme>((theme) => ({
  modal: {
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "8px",
    maxWidth: "520px",
    width: "100%",
    minHeight: "278px",
    maxHeight: "90vh",
    overflowY: "auto",
    overflowX: "hidden",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    [theme.breakpoints.down("xs")]: {
      maxWidth: "90vh",
    },
  },
  content: {
    height: "100%",
    width: "100%",
    padding: "24px",
  },
  badgeContent: {
    display: "flex",
    alignItems: "baseline",
    flexDirection: "row",
  },
  shareBadge: {
    backgroundColor: "rgba(48, 140, 219, 0.3)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "16px",
    height: "40px",
    width: "40px",
    marginBottom: "16px",
  },
  title: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: "20px",
    lineHeight: "28px",
    color: "#232325",
    position: "relative",
    top: "-4px",
  },
  closeButton: {
    position: "relative",
    top: "-8px",
  },
  subtitle: {
    font: "500 16px/24px Inter",
    color: `${text_default_color}`,
    marginBottom: 20,
  },
  shareTypeList: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    listStyle: "none",
    paddingRight: 0,
    "& li": {
      padding: "7px 13px",
      color: `${text_second_color}`,
      cursor: "pointer",
      font: "700  Manrope",
      "&.active": {
        borderRadius: 8,
        backgroundColor: `${background_second_color}`,
      },
    },
  },
  buttonShare: {
    width: 92,
    border: "1px solid #E6E9F1",
    color: `${text_default_color} !important`,
    "& div[role=progressbar]": {
      color: `${text_default_color}`,
    },
  },
}));

export default styles;
